import { createContext, useContext, useState, useEffect } from "react";
import { supabase } from "./supabaseClient";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const fetchUserAndLevel = async () => {
      const {
        data: { session },
      } = await supabase.auth.getSession();

      const authUser = session?.user || null;

      if (authUser) {
        // ✅ Fetch id, display_name, and user_level_id from users table
        const { data: appUser, error } = await supabase
          .from("users")
          .select("id, display_name, user_level_id")
          .eq("id", authUser.id)
          .single();

        if (error) {
          console.warn("Error fetching user_level_id from users table:", error.message);
          setUser(authUser);
        } else {
          setUser({ ...authUser, ...appUser });
        }
      } else {
        setUser(null);
      }
    };

    fetchUserAndLevel();

    // Listen for login/logout changes
    const { data: listener } = supabase.auth.onAuthStateChange((_event, session) => {
      const authUser = session?.user || null;

      if (authUser) {
        supabase
          .from("users")
          .select("id, display_name, user_level_id")
          .eq("id", authUser.id)
          .single()
          .then(({ data: appUser, error }) => {
            if (error) {
              console.warn("Error fetching user_level_id on auth change:", error.message);
              setUser(authUser);
            } else {
              setUser({ ...authUser, ...appUser });
            }
          });
      } else {
        setUser(null);
      }
    });

    return () => {
      listener.subscription.unsubscribe();
    };
  }, []);

  return (
    <UserContext.Provider value={{ user }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
